function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4025 18.6998L20.7803 19.9023L21.7162 21.9127L24.2327 22.4764L24.8982 24.5056L27.9347 24.919L28.0803 22.3637L29.4113 21.086L28.309 18.2488L25.6053 19.1319L22.4025 18.6998Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeWidth: 1.23512,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5611 17.61L34.5492 10.8083L34.2788 11.5411L33.9668 4.7206C33.946 4.47634 34.0916 4.25087 34.3204 4.15692L41.9947 1.03792C42.4939 0.831235 42.8682 1.52643 42.3691 1.7519L34.8611 5.15275L35.2147 4.58907L36.3793 11.3344C36.4209 11.6162 36.317 11.8793 36.109 12.0672L29.121 18.8689C28.2267 19.7707 26.6668 18.4743 27.6027 17.5912L27.5611 17.61Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7682 24.3553C28.7682 24.3553 33.9884 30.7624 34.0092 30.8C34.1756 30.9879 34.2172 31.2321 34.1756 31.4576L33.0941 36.5119L32.8861 35.9482L37.0457 40.4576C37.3368 40.7582 36.8377 41.1904 36.5257 40.9086L31.7839 36.8877C31.5967 36.7374 31.5551 36.5119 31.5759 36.3052L32.1166 31.1946L32.3038 31.8898L27.0836 25.4826C26.2933 24.4868 27.9363 23.3783 28.7682 24.3741V24.3553Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.948 20.8614L12.4635 17.322L13.2413 17.3957L8.27965 18.3359C8.00634 18.4096 7.66996 18.3359 7.52279 18.1331L4.5584 14.4646C4.45328 14.3355 4.49532 14.1512 4.64249 14.059C4.76863 13.9668 4.95785 13.9853 5.06297 14.0959L8.65809 17.322L7.90123 17.1192L12.6947 15.6444C12.968 15.5522 13.2413 15.6075 13.4726 15.7181L21 19.5C22 20 21.7194 22.0715 20.5 21.5L19.948 20.8614Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1589 20L44.7308 22.3681C45.13 22.4253 45.0701 23.0365 44.6509 22.9983L29 22L29 19L30.1589 20Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5655 18.1883L24.7319 9.43251C24.7319 9.03794 25.3974 9.01915 25.439 9.39493L26.6453 18.0755C26.8116 19.3908 24.5655 19.5035 24.5655 18.1695V18.1883Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8137 22.7582L16.3253 24.4146C15.9301 24.5837 15.4631 24.1147 15.8374 23.9268L20.8778 21.086C22.1257 20.4283 23.1448 22.2321 21.8137 22.7582Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8047 25.4248L20.9438 30.7271L21.0663 30.478L19.8001 34.7483C19.6979 35.1576 18.9423 35.033 19.0035 34.6238L19.6367 30.2467C19.6367 30.1399 19.6979 30.0688 19.7592 29.9976L24.1299 24.3928C24.9264 23.3964 26.6216 24.4995 25.7638 25.4426L25.8047 25.4248Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1585 18.5558L18.0422 13.4192C17.8486 13.1219 18.3712 12.8411 18.6035 13.1054L22.7844 17.6639C23.6167 18.6053 21.8166 19.5963 21.1585 18.5558Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M7.68545 41.7808C7.1316 41.7808 6.60044 42.0008 6.20881 42.3924C5.81718 42.784 5.59717 43.3152 5.59717 43.869V43.869C5.67725 44.3578 5.92847 44.8023 6.30597 45.1229C6.68346 45.4436 7.16265 45.6197 7.65797 45.6197C8.15328 45.6197 8.63247 45.4436 9.00997 45.1229C9.38746 44.8023 9.63868 44.3578 9.71877 43.869V43.869C9.71896 43.3246 9.5065 42.8016 9.12668 42.4115C8.74686 42.0214 8.22971 41.7951 7.68545 41.7808Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5.69336 25.6653V36.6563C5.69336 37.181 5.90179 37.6842 6.27281 38.0552C6.64382 38.4262 7.14703 38.6346 7.67173 38.6346C8.19642 38.6346 8.69963 38.4262 9.07065 38.0552C9.44166 37.6842 9.6501 37.181 9.6501 36.6563V25.6653C9.6501 25.1406 9.44166 24.6374 9.07065 24.2664C8.69963 23.8954 8.19642 23.687 7.67173 23.687C7.14703 23.687 6.64382 23.8954 6.27281 24.2664C5.90179 24.6374 5.69336 25.1406 5.69336 25.6653V25.6653Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDamageTypeMismatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageTypeMismatch);
export default __webpack_public_path__ + "static/media/damage-type-mismatch.5d544431ed4f574b1a7fe50fc3005fdd.svg";
export { ForwardRef as ReactComponent };